<template>
  <router-link to="#" class="buy-btn-comp">
   
      <span class="regular f-30 w__change">{{$fn.tr('შეძენა')}}</span>
    
  </router-link>
</template>

<script>
export default {
  props: ['link'],
  data(){
    return{
      loaded: false,
    }
  },
  computed:{
     getShopLink(){
        let _m = this.$store.state.main.indx.menus;
      let dup = [..._m]
      dup = dup.filter(m => m.configs.includes("shop"))
      return dup[0].full_url;
      }
  },
  
};
</script>

<style lang="scss" scoped>
.buy-btn-comp {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background: url('../assets/img/buybtn.png');
  background-size: cover;
  background-repeat: no-repeat;
  width: 173px;
  height: 60px;
  
 
  transition: 0.3s;
  transition-delay: 0.3s;
    span{
        color: white;
    }
 

  transition-delay: 0s;
  transition: all cubic-bezier(0, 0.08, 0.06, 0.99) 0.5s;
  @media (min-width: 1024px) {
    &:hover {
      transform: scale(1.1) rotate(-2deg);
    }
  }
}
</style>
